export async function generateAi({ prompt, token, options }) {
  const resp = await fetch(`${process.env.REACT_APP_BACKEND_URL}/generateAi`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ prompt, options }),
  });

  if (!resp.ok) {
    const err = await resp.json().catch(() => ({}));
    throw new Error(err.message || `AI request failed (${resp.status})`);
  }

  const json = await resp.json();
  return json.response;
}

/** Best-effort JSON extraction: models sometimes wrap JSON in prose or code fences. */
export function parseAiJson(text) {
  if (typeof text !== "string") return null;
  const fenced = text.match(/```(?:json)?\s*([\s\S]*?)```/i);
  const candidate = fenced ? fenced[1] : text;
  const braceMatch = candidate.match(/\{[\s\S]*\}/);
  const jsonStr = braceMatch ? braceMatch[0] : candidate;
  try {
    return JSON.parse(jsonStr);
  } catch {
    return null;
  }
}
